const Footer = () => {
  return (
    <div className="w-full bg-blue-900 text-white text-right py-2 px-10 fixed bottom-0 flex justify-end z-[999]">
      Powered by M
      <span className="text-red-500 font-semibold footer-text text-[16.5px]">
        E
      </span>
      EST®
    </div>
  );
};

export default Footer;
